<template>
  <div class="favorite">
    <header class="flex aic bg-fff pt-10 pb-10 pl-10 pr-10">
      <p class="red ml-10 flex aic f14" @click="$router.back()">
        <van-icon name="arrow-left" />
        <span>返回</span>
      </p>
      <van-search class="fg1" v-model="value" placeholder="请输入搜索关键词" show-action @search="onSearch">
        <div slot="action" @click="isEdit=!isEdit">管理</div>
      </van-search>
    </header>

    <div class="list flex fww jc-sb f14">
      <!-- 单个商品 -->
      <div class="flex2 jc-sb aic item pb-5 fg1 bg-fff">
        <img class="img" src="../../assets/img/miaosha-icon.png" alt />
        <div class="text flex2 jc-c w100pc">
          <span>新鲜水果</span>
          <span class="mt-3 red">¥9.00</span>
          <p class="flex jc-sb mt-5 aic">
            <span class="f999 f12 fcc">4人付款</span>
            <span style="width: 20px;height:20px;" class="fcc">
              <van-icon class="red" name="add-o" v-if="isEdit" />
              <van-checkbox v-else v-model="checked"></van-checkbox>
            </span>
          </p>
        </div>
      </div>
      <!-- 单个商品 -->
      <div class="flex2 jc-sb aic item pb-5 fg1 bg-fff">
        <img class="img" src="../../assets/img/miaosha-icon.png" alt />
        <div class="text flex2 jc-c w100pc">
          <span>新鲜水果</span>
          <span class="mt-3 red">¥9.00</span>
          <p class="flex jc-sb mt-5 aic">
            <span class="f999 f12 fcc">4人付款</span>
            <span style="width: 20px;height:20px;" class="fcc">
              <van-icon class="red" name="add-o" v-if="isEdit" />
              <van-checkbox v-else v-model="checked"></van-checkbox>
            </span>
          </p>
        </div>
      </div>
      <!-- 单个商品 -->
      <div class="flex2 jc-sb aic item pb-5 fg1 bg-fff">
        <img class="img" src="../../assets/img/miaosha-icon.png" alt />
        <div class="text flex2 jc-c w100pc">
          <span>新鲜水果</span>
          <span class="mt-3 red">¥9.00</span>
          <p class="flex jc-sb mt-5 aic">
            <span class="f999 f12 fcc">4人付款</span>
            <span style="width: 20px;height:20px;" class="fcc">
              <van-icon class="red" name="add-o" v-if="isEdit" />
              <van-checkbox v-else v-model="checked"></van-checkbox>
            </span>
          </p>
        </div>
      </div>
      <!-- 单个商品 -->
      <div class="flex2 jc-sb aic item pb-5 fg1 bg-fff">
        <img class="img" src="../../assets/img/miaosha-icon.png" alt />
        <div class="text flex2 jc-c w100pc">
          <span>新鲜水果</span>
          <span class="mt-3 red">¥9.00</span>
          <p class="flex jc-sb mt-5 aic">
            <span class="f999 f12 fcc">4人付款</span>
            <span style="width: 20px;height:20px;" class="fcc">
              <van-icon class="red" name="add-o" v-if="isEdit" />
              <van-checkbox v-else v-model="checked"></van-checkbox>
            </span>
          </p>
        </div>
      </div>

      <div class="item pb-5 fg1"></div>

      <van-submit-bar :price="3050" button-text="提交订单" @submit="onSubmit" />

      <van-submit-bar button-text="一键删除" @submit="onSubmit">
        <van-checkbox v-model="checked">全选</van-checkbox>
      </van-submit-bar>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isEdit: false,
      value: "",
      checked: false
    };
  },

  methods: {
    edit() {},
    onSearch() {},
    onSubmit() {}
  }
};
</script>

<style lang="less">
.favorite {
  .van-search {
    padding: 0;
    border-radius: 10px;
    margin-left: 10px;
  }
  .item {
    margin-top: 10px;
    width: 40vw;
  }
  .item:nth-child(even) {
    height: 170px;
    margin-left: 10px;
  }
  .img {
    width: 100px;
    height: 100px;
  }
  .text {
    padding: 5px 15px;
  }
  .van-submit-bar__bar {
    padding-left: 15px;
    justify-content: space-between;
  }
  .van-submit-bar__button {
    border-top-left-radius: 50%;
    background: linear-gradient(to right, #ffd01e, #c03131);
    border: none;
    height: 40px;
  }
}
</style>